import { render, staticRenderFns } from "./PaymentAllBanks.vue?vue&type=template&id=1f4be985&scoped=true&"
import script from "./PaymentAllBanks.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PaymentAllBanks.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PaymentAllBanks.vue?vue&type=style&index=0&id=1f4be985&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4be985",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconArrowLeft: require('/usr/www/nuxt/components/Icon/IconArrowLeft.vue').default})
